<p>promotions-tag works!</p>
